import { Typography } from '@compass/components'

import { IdentificationUrlKeys } from '../../../types'
import { visitFilterLabelMap } from '../../../utils/const'
import { CellAction } from './CellAction'
import { columnHelper, isBrowser } from './columnHelper'
import { NotApplicable, Unavailable } from './MissingData'

const key = IdentificationUrlKeys.BrowserTampering
const label = visitFilterLabelMap[key]

export const browserTamperingColumn = () =>
  columnHelper.display({
    id: 'browserTampering',
    header: 'Browser Tampering',
    cell: ({ row }) => {
      if (!isBrowser(row.original)) {
        return <NotApplicable />
      }

      const result = row.original.tampering

      if (result == null) {
        return <Unavailable />
      }

      return (
        <CellAction search={(old) => ({ ...old, [key]: result })} field={label}>
          <Typography className={result ? 'text-red-800' : ''}>{result ? 'Yes' : 'No'}</Typography>
        </CellAction>
      )
    },
  })
